<script setup>
defineProps({
    size: {
        type: Number,
        default: 16
    },
    color: {
        type: String,
        default: 'white'
    }
});
</script>

<template>
    <svg
        class="inline-block animate-spin"
        :width="size"
        :height="size"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        style="transition: all 0.3s ease-in-out"
    >
        <!-- Orbiting dots creating a circular pattern -->
        <circle cx="25" cy="6" r="3" :fill="color" opacity="1" style="transition: fill 0.3s ease-in-out" />
        <circle cx="38" cy="12" r="3" :fill="color" opacity="0.85" style="transition: fill 0.3s ease-in-out" />
        <circle cx="44" cy="25" r="3" :fill="color" opacity="0.7" style="transition: fill 0.3s ease-in-out" />
        <circle cx="38" cy="38" r="3" :fill="color" opacity="0.55" style="transition: fill 0.3s ease-in-out" />
        <circle cx="25" cy="44" r="3" :fill="color" opacity="0.4" style="transition: fill 0.3s ease-in-out" />
        <circle cx="12" cy="38" r="3" :fill="color" opacity="0.25" style="transition: fill 0.3s ease-in-out" />
        <circle cx="6" cy="25" r="3" :fill="color" opacity="0.15" style="transition: fill 0.3s ease-in-out" />
        <circle cx="12" cy="12" r="3" :fill="color" opacity="0.05" style="transition: fill 0.3s ease-in-out" />
    </svg>
</template>